import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const selector = '.splitkon-latest-news ul.swiper-container';

if ( document.querySelector( selector ) ) {
    const breakpoint = window.matchMedia( '(min-width:992px)' );
    let swipers = [];
    const breakpointChecker = function ( event ) {   // if larger viewport and multi-row layout needed
        if ( event.target.matches === true ) {      // clean up old instances and inline styles when available
            if ( swipers !== undefined ) {
                if ( Array.isArray( swipers ) ) {
                    swipers.forEach( ( instance ) => {
                        instance.destroy( true, true );
                    } );

                } else {
                    swipers.destroy( true, true );
                }
            }
        } else if ( breakpoint.matches === false ) {      // fire small viewport version of swiper
            return enableSwiper();
        }
    };

    breakpoint.addEventListener( 'change', breakpointChecker );// kickstart

    const enableSwiper = () => {
        swipers = new Swiper( selector, {
            createElements: true,
            loop: false,
            slideClass: 'wp-block-post',
            slidesPerView: 'auto',
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                formatFractionCurrent: function ( number ) {
                    return number < 10 ? '0' + number : number;
                },
                formatFractionTotal: function ( number ) {
                    return number < 10 ? '0' + number : number;
                },
            },
            navigation: {
                nextEl: '.nyg-swiper-button-next',
                prevEl: '.nyg-swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            // Responsive breakpoints
            breakpoints: {
                576: {
                    spaceBetween: 40,
                    slidesPerGroup: 1,
                }
            },
            a11y: false,
            on: {
                destroy: function () {
                    const nodeToRemove = this.slidesEl;
                    const parentNode = nodeToRemove.parentNode;

                    // Insert children before removing the node
                    while ( nodeToRemove.firstChild ) {
                        parentNode.insertBefore( nodeToRemove.firstChild, nodeToRemove );
                    }

                    // Remove the node itself
                    parentNode.removeChild( nodeToRemove );
                },
                /*
                this is a workaround to fix the issue with swiper not setting
                the last slide to active when using slidesPerView: 'auto'
                 */
                slideChange: function() {
                    this.slidesGrid = [...this.snapGrid];
                },
                resize: function() {
                    this.slidesGrid = [...this.snapGrid];
                },
            },
        } );
    }

    if ( !breakpoint.matches ) {
        enableSwiper();
    }
}
